import axios from 'axios';
import saveAs from 'file-saver';

export const exportDataRequest = async (type, data) =>
{

    let action ='export/'+type;
    if (type.startsWith("export_")) {
        action = type;
    }

    try {
        const response = await axios({
            method: 'get',
            url: '/api/v3/'+action,
            baseURL: process.env.REACT_APP_API_ROOT,
            params: data,
            responseType: 'blob',
        });

        // extract the filename from the content-disposition header
        const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
        const filename = contentDisposition
            ? /filename=["]?([^"]+)["]?/g.exec(contentDisposition)?.[1]
            : 'downloaded_file';

        // save the file using the file-saver
        saveAs(response.data, filename);
        return filename; // resolve with the filename
    } catch (error) {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    }
};


// mails the Excel overview of the agency / location settings to the given email
// (backend default: the logged in user), see ExportController::sendAgencyLocationSettingsExport
export const sendAgencyLocationSettingsRequest = async (email) =>
{
    try {
        const response = await axios({
            method: 'post',
            url: '/api/v3/export/agency_location_settings',
            baseURL: process.env.REACT_APP_API_ROOT,
            data: { email },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// mails the BK-Bedarfe with deployments of several agencies (CSV) to the given email
// (backend default: the logged in user), see ExportController::sendMixedAgencyCareNeedsExport
export const sendMixedAgencyCareNeedsRequest = async (email) =>
{
    try {
        const response = await axios({
            method: 'post',
            url: '/api/v3/export/mixed_agency_care_needs',
            baseURL: process.env.REACT_APP_API_ROOT,
            data: { email },
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    }
};

export const syncCustomerDataRequest = async (params) =>
{
    try {
        const response = await axios({
            method: 'get',
            url: '/api/v3/datev/syncDebitorData',
            params: params,
            baseURL: process.env.REACT_APP_API_ROOT,
        });

        // The API sometimes returns a double-encoded JSON string.
        // We parse it here to ensure a consistent object is always returned.
        if (typeof response.data === 'string') {
            return JSON.parse(response.data);
        }
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    }
}

export const getNurseDeploymentFixationData = async () => {
    try {
        const response = await axios({
            method: 'get',
            url: '/api/v3/nurseDeploymentFixations',
            baseURL: process.env.REACT_APP_API_ROOT,
        });

        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    }
}

export const getLocationAgency = async (locationId, agencyId) => {
    try {
        const response = await axios({
            method: 'get',
            url: '/api/v3/location_agencies/'+locationId+'/'+agencyId,
            baseURL: process.env.REACT_APP_API_ROOT,
        });

        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    }
}
